import moment from "moment";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../redux/store";
import BarekamCheckbox from "../../../components/checkbox";
import BarekamButton, { SimpleButtons } from "../../../components/button";
import { Message, MessageSections } from "../../../components/message/message";
import { Stack, useTheme } from "@mui/material";
import { NotificationModel } from "../../../../redux/reducers/user-notifications.reducer";
import BarekamText from "../../../components/text";
import {
    NotificationListContainer,
    NotificationListItemContainer,
    NotificationListItemTitle,
    NotificationsListHeader,
    NotificationsListHeaderItem
} from "./styled";
import { useNavigate } from "react-router-dom";
import {
    changePagination,
    getNotifications,
    updateNotificationsById
} from "../../../../redux/slices/user-notifications.slice";
import BarekamPagination from "../../../orders/my/pagination/barekam-pagination";

export const NotificationsList = () => {
    const [isReady, setIsReady] = useState<boolean>(false);

    const [onlyUnread, setOnlyUnread] = useState<boolean>(false);

    const { notificationsData } = useAppSelector(state => state.userNotificationsReducer);

    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const theme = useTheme();

    useEffect(() => {
        const filter = onlyUnread ? { seen: false } : {};
        if(!isReady) {
            Promise.allSettled([
                dispatch(getNotifications({ filter, page: 0 }))
            ]).then(() => {
                setIsReady(true);
            })
        }
    }, [isReady, onlyUnread]);

    function markAllResolved() {
        const notificationIds = notificationsData.userNotifications.map((notification) => notification.userNotificationId);
        Promise.allSettled([
            dispatch(updateNotificationsById({ notificationId: notificationIds, data: { seen: true } }))
        ]).then(() => {
            setIsReady(false);
        })
    }

    function openNotification(userNotificationId: number) {
        Promise.allSettled([
            dispatch(updateNotificationsById({ notificationId: [userNotificationId], data: { seen: true } }))
        ]).then(() => {
            navigate(`${userNotificationId}`);
        })
    }

    function handlePageChange(event: any, newPage: number): void {
        const filter = onlyUnread ? { seen: false } : {};
        dispatch(changePagination({ pageSize: notificationsData.pageSize, currentPage: newPage - 1 }));
        dispatch(getNotifications({ filter, page: newPage - 1 }));
    }

    const NotificationListItem = ({ notification }: { notification: NotificationModel }) => {

        return (
            <NotificationListItemContainer onClick={() => openNotification(notification.userNotificationId)}
                style={{
                    backgroundColor: notification.seen
                        ? theme.barekam.notifications.items.seen.background
                        : theme.barekam.notifications.items.unSeen.background
                }}>

                <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                    <NotificationListItemTitle>
                        <BarekamText variant={'l'} bold={!notification.seen}>
                            <Message messageKey={notification.subject} sectionId={MessageSections.MAIN} />
                        </BarekamText>

                        <BarekamText variant={'m'} opaque>
                            {moment(notification.sendDate).format('DD/MM/YYYY, HH:mm')}
                        </BarekamText>
                    </NotificationListItemTitle>
                </div>
            </NotificationListItemContainer>
        )
    }

    if (isReady) {
        return (
            <NotificationListContainer>
                <NotificationsListHeader>
                    <NotificationsListHeaderItem>
                        <BarekamCheckbox onClick={() => setOnlyUnread(prevState => !prevState)}
                            checked={onlyUnread} />
                        <BarekamText variant={'m'} opaque>
                            <Message messageKey={'only_unread'} sectionId={MessageSections.MAIN} />
                        </BarekamText>

                    </NotificationsListHeaderItem>

                    <BarekamButton type={SimpleButtons.LINK} onClick={() => markAllResolved()}>
                        <BarekamText variant={'m'} bold>
                            <Message messageKey={'mark_all_resolved'} sectionId={MessageSections.MAIN} />
                        </BarekamText>

                    </BarekamButton>
                </NotificationsListHeader>

                {notificationsData.userNotifications.length
                    ? <Stack sx={{ minWidth: '335px', width: '100%' }}>
                        {notificationsData.userNotifications.map((notification, index) => (
                            <NotificationListItem key={index} notification={notification} />
                        ))}
                    </Stack>
                    : <div style={{ paddingBottom: '1rem' }}>
                        <BarekamText variant={"l"} bold opaque align={"center"}>
                            <Message messageKey={'no_notifications'} sectionId={MessageSections.MAIN} />
                        </BarekamText>
                    </div>
                }

                <BarekamPagination {...notificationsData} onPageChange={handlePageChange} />
            </NotificationListContainer>
        );
    } else {
        return <></>
    }

}
